import { jsxs, jsx } from "react/jsx-runtime";
import * as RadixToast from "@radix-ui/react-toast";
import { concat } from "../../utils/classNames.js";
import "../../utils/globals.js";
import "./toast.theme.css.js";
const Toast = ({ title, description, content, duration, position, closeButtonIcon, hideClose, className, testId, additionalProps = {} }) => {
  return jsxs(RadixToast.Root, { className: concat("arm-toast", className), duration, "data-position": position, "data-testid": testId, "aria-label": "Notification", ...additionalProps, children: [title && jsx(RadixToast.Title, { className: "arm-toast-title", children: title }), description && jsx(RadixToast.Description, { className: "arm-toast-description", children: description }), closeButtonIcon !== false && !hideClose && jsx(RadixToast.Close, { className: "arm-toast-close", "aria-label": "Close", children: closeButtonIcon }), content] });
};
Toast.displayName = "Toast";
export {
  Toast
};
//# sourceMappingURL=toast.component.js.map
